import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="property-sidebar"
export default class extends Controller {
  connect() {
  }
}
